import LinkWithPage from './link-with-page';

export default LinkWithPage;
